import { useMutation, useQueryClient } from '@tanstack/react-query';
import { tradingCompetitionKeys } from './tradingCompetition.keys';
import { refreshUserScore } from './tradingCompetition.service';
export const useRefreshUserScore = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ subdomain, tradingCompetitionId, }) => refreshUserScore(subdomain, tradingCompetitionId),
        onSuccess: async (_, { subdomain, tradingCompetitionId }) => {
            // Invalidate relevant queries that might be affected by the score refresh
            await Promise.all([
                queryClient.invalidateQueries({
                    queryKey: tradingCompetitionKeys.leaderboard(subdomain, tradingCompetitionId, 1, 20),
                }),
                queryClient.invalidateQueries({
                    queryKey: tradingCompetitionKeys.userTradingRank(subdomain, tradingCompetitionId, ''),
                    exact: false, // This will invalidate all user rank queries for this competition
                }),
            ]);
        },
    });
};
